import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS,OFFER_CATEGORIES} from '@chekin/core';
import {API} from '@chekin/api';

const CACHE_TIME = 60_000;
const STALE_TIME = 60_000;

type CategoryValue = (typeof OFFER_CATEGORIES)[keyof typeof OFFER_CATEGORIES] | null;

type UseFetchOffersParams = {
  housingId?: string;
  category?: CategoryValue;
};

function useFetchOffers({housingId, category}: UseFetchOffersParams) {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.offers, housingId, category],
    queryFn: () => {
      const params = new URLSearchParams();
      params.append('housing_id', housingId!);
      params.append('is_active', 'true');

      if (category) {
        params.append('category', category);
      }

      return API.upselling.getOffers(params.toString());
    },
    enabled: Boolean(housingId),
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
  });
}

export {useFetchOffers};
